import React, { Component } from 'react';
import './App.css';
import MjfreWebsite from './pages/MjfreWebsite'

class App extends Component {
  render() {
    return (
      <div style={{ height: '100%'}}>
        <MjfreWebsite/>
      </div>
    );
  }
}

export default App;
